export default __webpack_public_path__ + "static/media/male-rounder.cbca0ca7.webp";